import React from 'react';
import {Box, Grid} from "@mui/material";
import {AccountBalance, CreditCard} from "@mui/icons-material";
import {
  CardContent,
  CardContentFooter,
  CardStyles,
  CardTitleDefault,
  Flex,
  PaymentAch,
  PaymentListDescription,
  PaymentListIcon,
  PaymentListItem,
  PaymentListTitle,
  Title
} from "./styles/paymentMethodStyle";

const Documents = [
  {
    name: 'Instant',
    options: [
      "Requires you to enter your Online Banking credentials",
      "Not supported with your local banks Micro Deposit",
      "Can be used immediately",
      "No weekly transaction limit (based on available balance)",
    ]
  },
  {
    name: 'Micro Deposit',
    options: [
      'Requires you to enter your bank account info',
      'Cannot be used until micro deposits are received and verified',
      'Takes a few days to complete',
      'Supported with all Banks',
      'Weekly transaction limit of $25,000'
    ]
  }
]

const PaymentMethodType = (props) => {
  const { payWithAch, setACH, collectMicroDepositVerifyPayment, setMicroDeposit } = props;

  return <>
    <Flex>
      <CardStyles
        onClick={() => setACH(false)}
        variant={!payWithAch ? "contained" : "outlined"}
        color={!payWithAch ? "primary" : "secondary"}
      >
        <CreditCard />
        <CardTitleDefault variant='subtitle2' payWithAch={payWithAch}>Pay with Card</CardTitleDefault>
      </CardStyles>
      <CardStyles
        onClick={() => setACH(true)}
        variant={payWithAch ? "contained" : "outlined"}
        color={payWithAch ? "primary" : "secondary"}
      >
        <AccountBalance />
        <CardTitleDefault variant='subtitle2' payWithAch={!payWithAch}>Pay with ACH</CardTitleDefault>
      </CardStyles>
    </Flex>
    {payWithAch &&
      <Box>
        <Title>Select Bank Account Verify Method</Title>
        <Grid spacing={2} container alignItems='center'>
          <Grid item xs={6}>
            <PaymentAch
              onClick={() => setMicroDeposit(false)}
              variant={!collectMicroDepositVerifyPayment ? "contained" : "outlined"}
              color={!collectMicroDepositVerifyPayment ? "primary" : "secondary"}
              fullWidth={true}
            >
              Instant
            </PaymentAch>
          </Grid>
          <Grid item xs={6}>
            <PaymentAch
              onClick={() => setMicroDeposit(true)}
              variant={collectMicroDepositVerifyPayment ? "contained" : "outlined"}
              color={collectMicroDepositVerifyPayment ? "primary" : "secondary"}
              fullWidth={true}
            >
              Micro Deposit
            </PaymentAch>
          </Grid>
        </Grid>
        <CardContent>
          {Documents.map((item, index) => (
            <CardContentFooter key={index}>
              <PaymentListTitle>{item.name}</PaymentListTitle>
              {item.options.map((option, index) => (
                <PaymentListItem key={index}>
                  <PaymentListIcon />
                  <PaymentListDescription>
                    {option}
                  </PaymentListDescription>
                </PaymentListItem>
              ))}
            </CardContentFooter>
          ))}
        </CardContent>
      </Box>
    }
  </>
}

export default PaymentMethodType;
